import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=6f745f1a&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=6f745f1a&prod&lang=scss&scoped=true"
import style1 from "./Edit.vue?vue&type=style&index=1&id=6f745f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f745f1a",
  null
  
)

export default component.exports